<script setup>
import {ref, watch} from "vue"
import {usePage} from "@inertiajs/vue3";

const dialogMessage = ref('')
const page = usePage()
const showDialog = ref(false)
const dialogOptions = ref({
    confirmText: 'prosseguir',
    cancelText: 'cancelar',
})

let resolveDialog
const open = async (message = 'Dialog Message', type = 'confirm', options = {}) => {
    dialogMessage.value = message
    dialogOptions.value = {
        ...dialogOptions.value,
        ...options,
        type: type
    }

    showDialog.value = true

    return new Promise((resolve, reject) => {
        resolveDialog = resolve
        watch(showDialog, () => reject('dismissed'))
    }).then((answer) => {
        showDialog.value = false

        return answer
    })
}

const confirm = async (text, options) => {
    return open(text, 'confirm', options)
}

const alert = async (text) => {
    return open(text, 'alert', {confirmText: 'ok'})
}

defineExpose({confirm, alert})
</script>

<template>
    <v-dialog v-model="showDialog" :max-width="$vuetify.display.mobile ? '90vw' : '35vw'" persistent>
        <v-card max-width="450">
            <template v-slot:default>
                <v-row class="px-3 py-3 bg-primary" >
                    <v-col md="12" class="d-flex justify-center">
                        <v-img
                            width="150"
                            height="75"
                            :src="page.props.logoUrl"
                            contain
                            eager
                        />
                    </v-col>
                </v-row>
                <v-sheet class="pa-3">
                    <p>{{ dialogMessage }}</p>
                </v-sheet>
            </template>

            <template v-slot:actions>
                <v-row justify="end" class="pa-2">
                    <v-btn class="mx-2 bg-primary" :text="dialogOptions.confirmText"  @click="resolveDialog(true)" />
                    <v-btn v-if="dialogOptions.type === 'confirm'" class="mx-2" :text="dialogOptions.cancelText" @click="resolveDialog(false)" color="secondary" />
                </v-row>
            </template>
        </v-card>
    </v-dialog>
</template>
